export enum GroupPosition {
  None = 'none',
  Start = 'start',
  Middle = 'middle',
  End = 'end',
}

export function resolveGroupPosition(
  current: string | null | undefined,
  prev: string | null | undefined,
  next: string | null | undefined
): GroupPosition {  
  if (current == null) {
    return GroupPosition.None;
  }

  const matchesPrev = prev != null && prev === current;
  const matchesNext = next != null && next === current;

  if (matchesPrev && matchesNext) {
    return GroupPosition.Middle;
  }

  if (matchesNext) {
    return GroupPosition.Start;
  }

  if (matchesPrev) {
    return GroupPosition.End;
  }

  return GroupPosition.None;
}
